import { render, staticRenderFns } from "./Websitebuilding.vue?vue&type=template&id=3f68c84a"
import script from "./Websitebuilding.vue?vue&type=script&lang=js"
export * from "./Websitebuilding.vue?vue&type=script&lang=js"
import style0 from "./Websitebuilding.vue?vue&type=style&index=0&id=3f68c84a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports